import angular from 'angular';
import PrivacyController from "./form.controller";

let privacy = angular
    .module('privacy', [])
    .controller('PrivacyController', PrivacyController);

export default privacy;